module.exports = __webpack_public_path__ + "static/media/gt.f0da39a2.svg";